import { Categories } from "../Categories";

class AddressEndpoint extends Categories {
    constructor() {
        super("/Address");
    }
}

export default new AddressEndpoint();
